import { render, staticRenderFns } from "./OrganizQuestionDetail.vue?vue&type=template&id=3742a036&scoped=true&"
import script from "./OrganizQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./OrganizQuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrganizQuestionDetail.vue?vue&type=style&index=0&id=3742a036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3742a036",
  null
  
)

export default component.exports